import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AgendamentoDespesaService } from 'src/app/admihair/service/agendamento-despesa.service';
import { AgendamentoDespesa } from 'src/app/admihair/api/dto/agendamento-despesa';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-agendamento-despesa-listar',
  templateUrl: './agendamento-despesa-listar.component.html',
  styleUrls: ['./agendamento-despesa-listar.component.scss']
})
export class AgendamentoDespesaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  empresaSelecionada?: Empresa;
  agendamentosDespesas: AgendamentoDespesa[] = [];
  loadingDespesas: boolean = false;
  filtroCompetenciaVencimento: Date = new Date();

  constructor(private agendamentoDespesaService: AgendamentoDespesaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
      super(erroService, utilStorageService)
     }

  ngOnInit(): void {
    this.loadingDespesas = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarAgendamentos();
    }
  }


  
  listarAgendamentos() {
    this.loadingDespesas = true;
    this.agendamentoDespesaService
      .listarPorEmpresa(this.empresaSelecionada?.id!, this.filtroCompetenciaVencimento)
      .subscribe({
        next: (data: AgendamentoDespesa[]) => {
          this.agendamentosDespesas = data;
          this.loadingDespesas = false;
        },
        error: (err: any) => {
          this.loadingDespesas = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  pagarDespesa(id: number) {
    this._router.navigate(["/apps/agendamento-despesa/pagar/" + id], { relativeTo: this._activatedRoute })
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarAgendamento(id: number) {
    this._router.navigate(["/apps/agendamento-despesa/editar/" + id], { relativeTo: this._activatedRoute })
  }

  excluirAgendamento(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.agendamentoDespesaService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarAgendamentos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
            this.listarAgendamentos();
          }
        });
      }
    });
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_AGENDAMENTO_DESPESA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_AGENDAMENTO_DESPESA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_AGENDAMENTO_DESPESA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_AGENDAMENTO_DESPESA');
  }
}
